import React, { useCallback, useState } from 'react';
import { BusinessPartnerContext } from 'pages/BusinessPartnerManagement/BusinessPartnerContext';
import { useMutation, useQueryCache } from 'react-query';
import { BusinessPartnersAPI } from 'api/BusinessPartnersAPI';
import { QueryKey } from 'api/queryKey';
import { useEnsureContext } from 'common/hooks';
import { message } from 'antd';
import { FormikOnSubmit } from 'lib/formik.utils';
import { BusinessPartnerMedicalOperatorForm } from 'pages/BusinessPartnerManagement/BusinessPartnerMedicalOperatorsManagement/shared/BusinessPartnerMedicalOperatorForm';
import { MedicalOperatorFormModel } from 'models/medicalOperator';
import { Header } from 'common/components/Header';
import { useHistory } from 'react-router';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { BusinessPartnerRoutes } from 'pages/BusinessPartnerManagement/businessPartnerRoutes';

export const BusinessPartnerRegisterMedicalOperatorPage = () => {
  const bpContext = useEnsureContext(BusinessPartnerContext);
  const queryCache = useQueryCache();

  const [mutate, { isLoading }] = useMutation(
    BusinessPartnersAPI.registerNewMedicalOperator
  );

  const [mutateuserPermissions] = useMutation(
    BusinessPartnersAPI.updateUserPermissions
  );

  const [checkedDenyAccess, setCheckedDenyAccess] = useState(false);

  const history = useHistory();
  const intlMessage = useFormatMessage();

  const permissionItems = [
    {
      permission: 'ADMIN_PANEL_ACCESS',
      scope: 'PARTNER',
      enabled: checkedDenyAccess,
      read: checkedDenyAccess,
      create: checkedDenyAccess,
      update: checkedDenyAccess,
      delete: checkedDenyAccess,
    },
    {
      permission: 'DOCTOR_PORTAL_ACCESS',
      scope: 'PARTNER',
      enabled: checkedDenyAccess,
      read: checkedDenyAccess,
      create: checkedDenyAccess,
      update: checkedDenyAccess,
      delete: checkedDenyAccess,
    },
  ];

  const removeSpacesFromForm = (formData: MedicalOperatorFormModel) => {
    formData.phoneNumber = formData.phoneNumber

      .replace(/\s/g, '')
      .replace(/^0+/, '');
    formData.prefixCode = formData.prefixCode.replace(/\s/g, '');
    return formData;
  };

  const handleSubmit: FormikOnSubmit<MedicalOperatorFormModel> = useCallback(
    (formData, { resetForm }) => {
      const formDataToSend =
        formData.phoneNumber !== null
          ? removeSpacesFromForm(formData)
          : formData;

      mutate(
        {
          businessPartnerId: formDataToSend.partner
            ? formDataToSend.partner
            : bpContext.id,
          dto: formDataToSend,
        },
        {
          onSuccess: (res) => {
            checkedDenyAccess &&
              mutateuserPermissions({
                userId: res.userId,
                items: permissionItems,
              });
            resetForm();
            queryCache
              .invalidateQueries(QueryKey.BusinessPartnerMedicalOperatorsList)
              .then();
            message.success(
              intlMessage(
                { id: 'medicalOperators.register.success' },
                {
                  firstName: formData.firstName,
                  lastName: formData.lastName,
                }
              )
            );
            history.push(`../${BusinessPartnerRoutes.MedicalOperators}`);
          },
        }
      ).then();
    },
    [
      bpContext,
      mutate,
      queryCache,
      intlMessage,
      history,
      checkedDenyAccess,
      mutateuserPermissions,
      permissionItems,
    ]
  );
  return (
    <>
      <Header title={intlMessage({ id: 'medicalOperators.new' })} />
      <BusinessPartnerMedicalOperatorForm
        onSubmit={handleSubmit}
        loading={isLoading}
        setCheckedDenyAccess={setCheckedDenyAccess}
      />
    </>
  );
};
